



















import Vue from 'vue';
import { ModalSize } from '@/components/zen_modal/types';
import GenericCard from './GenericCard.vue';

export default Vue.extend({
  name: 'GenericConfirm',
  components: {
    GenericCard,
  },
  props: {
    title: {
      type: String,
      default: 'Are you sure?',
    },
    okTitle: {
      type: String,
      default: 'OK',
    },
    message: {
      type: String,
      default: 'This action might be permanent.',
    },
  },
  computed: {
    insideSPA(): boolean {
      // TODO: Temp. solution for ToDo list modals
      return !!this.$router && this.$route.name !== 'toDoList';
    },
  },
  created() {
    if (this.insideSPA) {
      this.$store.dispatch('modals/changeSize', ModalSize.Small);
    } else {
      this.$emit('updateConfig', { size: ModalSize.Small });
    }
    document.body.addEventListener('keydown', this.enterHandler);
  },
  destroyed() {
    document.body.removeEventListener('keydown', this.enterHandler);
  },
  methods: {
    resolve(resolution: boolean) {
      if (this.insideSPA) {
        if (resolution) {
          this.$store.dispatch('modals/confirm', resolution);
        } else {
          this.$store.dispatch('modals/cancel');
        }
      } else {
        window.GGRC.zenModal.$emit('confirmation', resolution);
        this.$emit('close');
      }
    },
    enterHandler(ev: KeyboardEvent) {
      if (ev.keyCode === 13 || ev.key === 'Enter') {
        this.resolve(true);
      }
    },
    closeHandler() {
      this.resolve(false);
    },
  },
});
